import type { TFunction } from "i18next";

type RtkError = {
    status?: number | string;
    data?: unknown;
};

const CODE_TO_KEY: Record<string, string> = {
    OUT_OF_STOCK: "errors.out_of_stock",
    PRODUCT_INACTIVE: "errors.product_unavailable",
    PRODUCT_NOT_FOUND: "errors.product_unavailable",
    ITEM_NOT_FOUND: "errors.item_not_found",
    INVALID_QUANTITY: "errors.invalid_quantity",
    CART_EMPTY: "errors.cart_empty",
};

// Translate an RTK Query cart-mutation error into a user-facing message.
// Falls back to a generic message so failures are never silently swallowed.
export const getCartErrorMessage = (error: unknown, t: TFunction): string => {
    const err = (error ?? {}) as RtkError;
    const status = err.status;

    if (status === "FETCH_ERROR" || status === "TIMEOUT_ERROR") {
        return t("errors.network");
    }
    if (status === 401 || status === 403) {
        return t("errors.session_expired");
    }
    if (status === 429) {
        return t("errors.rate_limited");
    }

    const data = err.data as { code?: string; details?: string } | undefined;
    if (data?.code && CODE_TO_KEY[data.code]) {
        return t(CODE_TO_KEY[data.code]);
    }
    if (typeof data?.details === "string" && data.details) {
        return data.details;
    }

    return t("errors.generic");
};
